import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/sections/HeroSection';
declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    _fbq: (...args: any[]) => void;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function (...args: any[]) {
    n.callMethod ? n.callMethod(...args) : n.queue.push(args);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [] as any[];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '1270442961879164');
  window.fbq('track', 'PageView');
}
import { EmpathySection } from './components/sections/EmpathySection';
import { MechanismSection } from './components/sections/MechanismSection';
import { WhatYouGetSection } from './components/sections/WhatYouGetSection';
import { TargetAudienceSection } from './components/sections/TargetAudienceSection';
import { PhasesSection } from './components/sections/PhasesSection';
import { FAQSection } from './components/sections/FAQSection';
import { OfferSection } from './components/sections/OfferSection';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen bg-cream font-sans text-gray-800" data-id="element-0">
      <HeroSection data-id="element-1" />
      <EmpathySection data-id="element-2" />
      <MechanismSection data-id="element-3" />
      <WhatYouGetSection data-id="element-4" />
      <TargetAudienceSection data-id="element-5" />
      <PhasesSection data-id="element-6" />
      <FAQSection data-id="element-7" />
      <OfferSection data-id="element-8" />

      <footer className="bg-forest text-cream/60 py-8 text-center text-sm" data-id="element-9">
        <div className="max-w-4xl mx-auto px-6" data-id="element-10">
          <p data-id="element-11">
            © {new Date().getFullYear()} Rescate Renal. Todos los derechos
            reservados.
          </p>
          <p className="mt-2 text-xs" data-id="element-12">
            Este producto no sustituye el consejo médico profesional. Consulte a
            su médico antes de iniciar cualquier protocolo nutricional.
          </p>
        </div>
      </footer>
    </div>;
}